import { render, staticRenderFns } from "./ButtonSideBarWeightUpdate.vue?vue&type=template&id=e077eb5e"
import script from "./ButtonSideBarWeightUpdate.vue?vue&type=script&lang=js"
export * from "./ButtonSideBarWeightUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports